import React from 'react';
import { Alert, AlertTitle, Paper } from '@mui/material';
import { type GridColDef } from '@mui/x-data-grid-premium';

import { Icon, useSettings } from 'app/main/components';
import { ViewTable, ViewTableUtils } from 'app/main/components/page-layouts';

interface CommunicationsReadReceiptsTabProps {
	comsUid: string;
	showReadReceipts: boolean;
	refresh: boolean;
	updateRefresh: VoidFunction;
}

export default function CommunicationsReadReceiptsTab({
	comsUid,
	showReadReceipts,
	refresh,
	updateRefresh
}: CommunicationsReadReceiptsTabProps) {
	const { t } = useSettings();

	const columns: GridColDef[] = [
		{
			field: 'user_title',
			headerName: t('DETAILS_COMMUNICATIONS_READ_RECEIPTS_FIELD_USER'),
			minWidth: 200,
			flex: 4,
			renderCell: ({ value, row }) => ViewTableUtils.renderCellWithTooltip({ value }),
			sortable: false,
			hideable: false
		},
		{
			field: 'cmrd_read',
			headerName: t('DETAILS_COMMUNICATIONS_READ_RECEIPTS_FIELD_READ'),
			minWidth: 100,
			flex: 1,
			renderCell: ({ value }) =>
				value ? <Icon icon="check" color="green" /> : <Icon icon="close" color="red" />,
			sortable: false,
			hideable: false
		},
		{
			field: 'cmrd_d_read',
			headerName: t('DETAILS_COMMUNICATIONS_READ_RECEIPTS_FIELD_DATE'),
			minWidth: 100,
			flex: 1,
			renderCell: ({ value }) =>
				value ? (
					ViewTableUtils.renderDate({
						value,
						format: {
							year: 'numeric',
							month: '2-digit',
							day: '2-digit',
							hour: '2-digit',
							minute: '2-digit',
							second: '2-digit'
						}
					})
				) : (
					<></>
				),
			sortable: false
		}
	];

	return showReadReceipts ? (
		<ViewTable
			module="communications_readreceipts"
			columns={columns}
			refresh={refresh}
			updateRefresh={updateRefresh}
			defaultFilters={[
				{ filt_field: 'coms_deleted', filt_clause: 'not_equal', filt_value: 1 },
				{ filt_field: 'user_enabled', filt_clause: 'equals', filt_value: 1 },
				{ filt_field: 'coms_uid', filt_clause: 'equals', filt_value: comsUid }
			]}
		/>
	) : (
		<Paper className="rounded-8" variant="outlined">
			<Alert className="rounded-8" severity="info" icon={<Icon icon="info-circle" />}>
				<AlertTitle>{t('TAB_READ_RECEIPTS_ALERT_TITLE')}</AlertTitle>
				{t('TAB_READ_RECEIPTS_ALERT_DESCRIPTION')}
			</Alert>
		</Paper>
	);
}
